export class ObjectName {
  id: string;
  name: string;
  description?: string;
  keywords?: string;
  parts?: Record<string, string>;
  address?: string;

  public static createInstance(jsonData: any): ObjectName {
    const v = Object.assign(new ObjectName(), jsonData);

    return v;
  }

  public static createInstances(jsonData: any[]): ObjectName[] {
    return jsonData.map(ObjectName.createInstance);
  }
}
